import React from 'react';
import _ from 'lodash'
import OutsideClickHandler from 'react-outside-click-handler';

import Jibber from '/app/src/jibber'
import {Flex, SVGButton, TextInput, RemoveItemModal} from '/app/src/component'

import SubItem from './_SubItem'
import LockItem from './_LockItem'
import style from './style.css'


const ListItemStyle = {
    width: '350px',
    height: '100%',
    vAlignContent: 'center',
    fontSize: '24px',
    paddingLeft: '20px',
    position: 'relative',
    borderRadius: '200px',
    cursor: 'pointer',
    backgroundHover: 'mediumgrey',
    backgroundColor: 'darkwhite',
    hover: 'black',
}

const VisibleIconStyle = (visible) => ({
    color: visible?'blue':'lightgrey',
    src:visible?'/images/Visible.svg':'/images/Hidden_M.svg',
    marginLeft: '20px'
})

const ButtonStyle = {
    color: 'lightblack',
    hover: 'blue'

}
const AddNewOptionInputStyle = {
    dataName: 'AddNewOptionInput',
    width: '300px',
    height: '45px',
    borderRadius: '200px',
    fontSize: '24px',
    vAlignContent: 'center',
    hAlignContent: 'right',
    color: 'black',
    marginBottom: '5px',
    position: 'relative'
}
const ButtonCreateSubItemStyle = {
    color: 'darkgrey',
    borderRadius: '200px',
    src: '/images/Save.svg',
    position: 'absolute',
    right: '10px',
    backgroundHover: 'transparent'
}
const TextInputNewSubItemStyle = {
    height: '35px',
    border: '3px solid',
    borderRadius: '200px',
    color: 'blue',
    marginLeft: '8px'
}

// EDIT
const EditOptionInputStyle = {
    dataName: 'EditOptionInput',
    width: '350px',
    borderRadius: '200px',
    fontSize: '24px',
    vAlignContent: 'center',
    color: 'black',
    position: 'relative',
}
const TextInputStyle = {
    border: '3px solid',
    borderRadius: '200px',
    color: 'blue'
}
const TextInputSaveButtonStyle = {
    color: 'darkgrey',
    borderRadius: '200px',
    src: '/images/Choose-Next_M.svg',
    position: 'absolute',
    right: '10px',
    backgroundHover: 'transparent'
}

export default class ExchangeItem extends Jibber {
    constructor(props){
        super(props)
        this.useState({
            hover: false,
            view: 'button',
            confirmRemoval: false,
            addNewVisible: false,
            newSubItemLabel: '',
        })

        this.editView = this.editView.bind(this)
        this.buttonView = this.buttonView.bind(this)
        this.confirmRemovalView = this.confirmRemovalView.bind(this)
    }


    editView(){
        const {setView} = this
        const {item} = this.props

        const _handleKeys = (e) => {
            if (['Enter', 'Escape'].includes(e.key)){
                setView('button')
            }
        }

        const TextInputProps = {
            value: item.label,
            onChange: (e)=>this.props.onUpdate(item.id, e.target.value, item.visible),
            //onChange: (e)=>setLabel(e.target.value),
            onKeyDown: _handleKeys,
            maxLength: 30,
            autoFocus: true,
        }

        return (
            <OutsideClickHandler
                onOutsideClick={()=>{_handleKeys({key: 'Escape'})}}
            >
            <Flex {...EditOptionInputStyle}>
                <TextInput
                    {...TextInputProps}
                    className={style.InnerTextInput}
                    {...TextInputStyle}
                />
            <SVGButton {...TextInputSaveButtonStyle} onClick={()=>{this.setView('button')}} hover='blue'/>
            </Flex>
            </OutsideClickHandler>
        )
    }
    buttonView(){
        const {item} = this.props
        const {hover} = this.state
        const {setHover, setView, setAddNewVisible} = this

        return (
            <Flex {...ListItemStyle}
                color={item.visible?'black':'darkgrey'}
                 onMouseEnter={()=>{setHover(true)}} onMouseLeave={()=>{setHover(false)}}>
                <Flex marginRight='auto'>
                    <div className='ellipsis'>
                        {item.label}
                    </div>
                </Flex>
                <Flex width='120px' shrink={0} grow={0}>
                {hover && (
                    <React.Fragment>
                        <SVGButton src='/images/Trash.svg'  {...ButtonStyle} hover='NegativeRed' onClick={()=>{this.setConfirmRemoval(true)}} w='40px'/>
                        <SVGButton src='/images/Edit.svg' {...ButtonStyle} onClick={()=>{setView('edit')}} w='40px'/>
                        <SVGButton src='/images/SubCategoryAdd_M.svg' {...ButtonStyle} onClick={()=>{setAddNewVisible(true)}} w='40px'/>
                    </React.Fragment>
                    )
                }
                </Flex>
            </Flex>
        )
    }
    newSubItem(){
        const {setAddNewVisible, setNewSubItemLabel} = this
        const {onCreateSubItem, item} = this.props
        const {newSubItemLabel} = this.state

        const _handleKeys = (e) => {
            if (e.key === 'Enter'){
                onCreateSubItem(newSubItemLabel, item.id)
                setNewSubItemLabel('')
                setAddNewVisible(false)
            }
            if (e.key === 'Escape'){
                setNewSubItemLabel('')
                setAddNewVisible(false)
            }
        }

        const TextInputProps = {
            value: newSubItemLabel,
            onChange: (e)=>setNewSubItemLabel(e.target.value),
            onKeyDown: _handleKeys,
            maxLength: 30,
            autoFocus: true,
        }

        return (
            <OutsideClickHandler
                onOutsideClick={()=>{_handleKeys({key: 'Escape'})}}
            >
            <Flex {...AddNewOptionInputStyle} marginLeft='auto' marginRight='60px'>
                <TextInput
                    {...TextInputProps}
                    className={style.InnerTextInput}
                    {...TextInputNewSubItemStyle}
                />
            <SVGButton {...ButtonCreateSubItemStyle} onClick={()=>{onCreateSubItem(newSubItemLabel, item.id)}}/>
            </Flex>
            </OutsideClickHandler>
        )
    }
    confirmRemovalView(){
    //<SVGButton src='/images/Trash.svg'  {...ButtonStyle} hover='NegativeRed'  this.setConfirmRemoval(false)}} w='40px'/>
        return (
            <RemoveItemModal
                title='Ta bort kanaler'
                open={this.state.confirmRemoval}
                onClose={()=>{this.setConfirmRemoval(false)}}
                text={<Flex w='100%' center>
                    <div> Är du säker på att du vill ta bort<strong> {this.props.item.label}</strong>?</div></Flex>}
                onRemoveClick={()=>{this.props.onDelete(this.props.item.id)}}
            />
        )
    }



    render(){
        const {item, onDelete, onUpdate} = this.props
        const {view, addNewVisible, confirmRemoval} = this.state
        return(
            <Flex column shrink={0} position='relative'>
                {confirmRemoval && this.confirmRemovalView()}
                <Flex height='45px' vAligncontent='center' hAlignContent='right' marginBottom='5px'>
                    {view === 'button' && this.buttonView()}
                    {view === 'edit' && this.editView()}
                    <SVGButton {...VisibleIconStyle(item.visible)}
                        onClick={()=>{
                            this.setView('button');
                            this.props.onUpdate(item.id, item.label, !item.visible)
                        }}
                    />
                </Flex>
                <Flex column width='360px' marginLeft='auto'>
                    {_.map(item.children, (sub)=>{
                        return <SubItem
                                key={sub.id}
                                parentId={item.id}
                                parentVisible={item.visible}
                                item={sub}
                                onDelete={onDelete}
                                onUpdate={onUpdate}/>
                    })}
                    {item.children && item.children.length !== 0 &&
                        <LockItem label='Övriga frågor' width='360' height='35px' fontSize='20px' parentVisible={item.visible}/>
                    }
                    {addNewVisible && this.newSubItem()}
                    </Flex>
            </Flex>
        )
    }
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/Exchange/_Item.js